module.exports = __webpack_public_path__ + "img/support-icon.a40e173d.svg";